import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import withCapabilities from '../../../hoc/withCapabilities'
import { CustomerRoutes } from '../../../config/routes.config'
import { LogoContainer, LogoImage, LogoSkeleton } from './HeaderLogo.styled'

const HeaderLogo: React.FC<{ logo: string }> = ({ logo }) => {
  const navigate = useNavigate()
  const [hasLoadedLogo, setHasLoadedLogo] = useState(false)

  useEffect(() => {
    setHasLoadedLogo(false)
  }, [logo])

  return (
    <>
      {!hasLoadedLogo && (
        <>
          <LogoSkeleton />
          {logo && <LogoImage alt="" src={logo} onLoad={() => setHasLoadedLogo(true)} style={{ display: 'none' }} />}
        </>
      )}
      {hasLoadedLogo && (
        <LogoContainer
          onClick={() => {
            navigate(CustomerRoutes.HOME)
          }}
        >
          <LogoImage alt="Logo" src={logo} />
        </LogoContainer>
      )}
    </>
  )
}

export default withCapabilities(HeaderLogo)
